module.exports = __webpack_public_path__ + "img/arrow_1.f2dc187a.svg";